export const dnldWhatsAppTemplates = (builder) => ({
    dnldWhatsAppTemplates: builder.mutation({
        query: ({ search, category, status, from, to, user_type, userId, loggedin_user_id, user_type_id, associated_enterprise_id }) => {
            return {
                url: '/download_whatsapp_template_list',
                method: 'GET',
                params: { search, category, status, from, to, user_type, userId, loggedin_user_id, user_type_id, associated_enterprise_id },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});